var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 4.371L18 19.7a.314.314 0 0 1-.188.258.278.278 0 0 1-.296 0l-5.086-2.53-1.836 2.436a.299.299 0 0 1-.258.133.333.333 0 0 1-.117-.016c-.146-.046-.219-.153-.219-.32v-3.326c0-.089.023-.156.07-.203l7.282-9.37-9.461 8.167a.39.39 0 0 1-.227.07.274.274 0 0 1-.148-.038l-3.329-1.664c-.125-.057-.187-.15-.187-.28 0-.13.055-.235.164-.313L19.5 4.043a.33.33 0 0 1 .352.016c.114.083.164.187.148.312z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.634ddad164f44bd1360805116ff2f215.svg";
export { ForwardRef as ReactComponent };